/* tslint:disable */
/* eslint-disable */
/**
 * EVIMO API
 * Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TicketCompletionRequestDto
 */
export interface TicketCompletionRequestDto {
    /**
     * 
     * @type {string}
     * @memberof TicketCompletionRequestDto
     */
    ticketId: string;
    /**
     * 
     * @type {string}
     * @memberof TicketCompletionRequestDto
     */
    executionResult: TicketCompletionRequestDtoExecutionResultEnum;
    /**
     * 
     * @type {object}
     * @memberof TicketCompletionRequestDto
     */
    summary?: object | null;
    /**
     * 
     * @type {object}
     * @memberof TicketCompletionRequestDto
     */
    workPerformed?: object | null;
    /**
     * 
     * @type {object}
     * @memberof TicketCompletionRequestDto
     */
    recommendation?: object | null;
    /**
     * 
     * @type {object}
     * @memberof TicketCompletionRequestDto
     */
    technicianComment?: object | null;
    /**
     * 
     * @type {object}
     * @memberof TicketCompletionRequestDto
     */
    assetOperational?: object | null;
    /**
     * 
     * @type {object}
     * @memberof TicketCompletionRequestDto
     */
    faultCategory?: object | null;
    /**
     * 
     * @type {object}
     * @memberof TicketCompletionRequestDto
     */
    faultDescription?: object | null;
    /**
     * 
     * @type {object}
     * @memberof TicketCompletionRequestDto
     */
    confirmedSerialNumber?: object | null;
    /**
     * 
     * @type {object}
     * @memberof TicketCompletionRequestDto
     */
    confirmedAssetIdentifier?: object | null;
    /**
     * 
     * @type {object}
     * @memberof TicketCompletionRequestDto
     */
    pauseDurationMinutes?: object | null;
    /**
     * 
     * @type {Date}
     * @memberof TicketCompletionRequestDto
     */
    arrivedAt?: Date | null;
    /**
     * 
     * @type {object}
     * @memberof TicketCompletionRequestDto
     */
    completedReading?: object | null;
}


/**
 * @export
 */
export const TicketCompletionRequestDtoExecutionResultEnum = {
    CompletedOk: 'COMPLETED_OK',
    CompletedWithIssue: 'COMPLETED_WITH_ISSUE',
    NotDone: 'NOT_DONE',
    Cancelled: 'CANCELLED'
} as const;
export type TicketCompletionRequestDtoExecutionResultEnum = typeof TicketCompletionRequestDtoExecutionResultEnum[keyof typeof TicketCompletionRequestDtoExecutionResultEnum];


/**
 * Check if a given object implements the TicketCompletionRequestDto interface.
 */
export function instanceOfTicketCompletionRequestDto(value: object): value is TicketCompletionRequestDto {
    if (!('ticketId' in value) || value['ticketId'] === undefined) return false;
    if (!('executionResult' in value) || value['executionResult'] === undefined) return false;
    return true;
}

export function TicketCompletionRequestDtoFromJSON(json: any): TicketCompletionRequestDto {
    return TicketCompletionRequestDtoFromJSONTyped(json, false);
}

export function TicketCompletionRequestDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): TicketCompletionRequestDto {
    if (json == null) {
        return json;
    }
    return {
        
        'ticketId': json['ticketId'],
        'executionResult': json['executionResult'],
        'summary': json['summary'] == null ? undefined : json['summary'],
        'workPerformed': json['workPerformed'] == null ? undefined : json['workPerformed'],
        'recommendation': json['recommendation'] == null ? undefined : json['recommendation'],
        'technicianComment': json['technicianComment'] == null ? undefined : json['technicianComment'],
        'assetOperational': json['assetOperational'] == null ? undefined : json['assetOperational'],
        'faultCategory': json['faultCategory'] == null ? undefined : json['faultCategory'],
        'faultDescription': json['faultDescription'] == null ? undefined : json['faultDescription'],
        'confirmedSerialNumber': json['confirmedSerialNumber'] == null ? undefined : json['confirmedSerialNumber'],
        'confirmedAssetIdentifier': json['confirmedAssetIdentifier'] == null ? undefined : json['confirmedAssetIdentifier'],
        'pauseDurationMinutes': json['pauseDurationMinutes'] == null ? undefined : json['pauseDurationMinutes'],
        'arrivedAt': json['arrivedAt'] == null ? undefined : (new Date(json['arrivedAt'])),
        'completedReading': json['completedReading'] == null ? undefined : json['completedReading'],
    };
}

export function TicketCompletionRequestDtoToJSON(json: any): TicketCompletionRequestDto {
    return TicketCompletionRequestDtoToJSONTyped(json, false);
}

export function TicketCompletionRequestDtoToJSONTyped(value?: TicketCompletionRequestDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'ticketId': value['ticketId'],
        'executionResult': value['executionResult'],
        'summary': value['summary'],
        'workPerformed': value['workPerformed'],
        'recommendation': value['recommendation'],
        'technicianComment': value['technicianComment'],
        'assetOperational': value['assetOperational'],
        'faultCategory': value['faultCategory'],
        'faultDescription': value['faultDescription'],
        'confirmedSerialNumber': value['confirmedSerialNumber'],
        'confirmedAssetIdentifier': value['confirmedAssetIdentifier'],
        'pauseDurationMinutes': value['pauseDurationMinutes'],
        'arrivedAt': value['arrivedAt'] == null ? value['arrivedAt'] : value['arrivedAt'].toISOString(),
        'completedReading': value['completedReading'],
    };
}

